import React from 'react'
import { Layout } from 'antd'
import './index.style.scss'
import AddNewIssuedCheckForm from './components/AddNewIssuedCheckForm'
import IssuedCheckList from './components/IssuedCheckList'

const AddNewIssuedCheckContent: React.FC = () => {
  return (
    <Layout.Content className='add-new-issued-check-container' style={{ padding: 24, marginBottom: 24 }}>
      <AddNewIssuedCheckForm />
      <IssuedCheckList />
    </Layout.Content>
  )
}

export default AddNewIssuedCheckContent
